<template>
  <div class="radio-wrap">
    <h3>{{ title }}</h3>
    <ul class="radio-list">
      <li class="radio-item">
        <div class="radio-btn" v-for="item in selectList" :key="item.id">
          <button @click="changeItem(item.id)" :class="{ active: item.id === defaultValue }">
            {{ item.name }}
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    selectList: {
      type: Array,
      required: true
    },
    defaultValue: [String, Number]
  },
  name: 'RadioSelect',

  data() {
    return {
      // currentValue: this.defaultValue,
    }
  },
  model: {
    prop: 'defaultValue',
    event: 'chooseItem'
  },
  methods: {
    changeItem(id) {
      // this.currentValue = id;
      this.$emit('chooseItem', id)
    }
  }
}
</script>
<style scoped lang="less">
.radio-wrap {
  font-size: 24px;
  h3 {
    padding-left: 10px;
    font-size: 28px;
    color: #111111;
    height: 80px;
    line-height: 80px;
  }
  .radio-list {
    display: flex;
    flex-wrap: wrap;
    .radio-item {
      width: 100%;
      display: flex;
      flex-flow: row wrap;
      .radio-btn {
        height: 100px;
        color: #333333;
        width: 33.333333%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      button {
        width: 90%;
        height: 70%;
        background: rgba(247, 247, 247, 1);
        border: 1px solid rgba(228, 228, 235, 1);
        border-radius: 8px;
        font-size: 26px;
      }
      .active {
        background: rgba(65, 150, 255, 1);
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
</style>
